'use client'

import { hasAdvertisingCookieConsent } from '@/components/cookie-consent-banner'
import { getSessionId } from '@/components/utils/session-tracking'

export function getActivationTrackingSessionId() {
  return hasAdvertisingCookieConsent() ? getSessionId() : null
}
